var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-list"},[_vm._t("header"),_c('ul',{staticClass:"list"},_vm._l((_vm.getElements),function(element){return _c('li',[_vm._t("default",function(){return [_c('span',{staticClass:"label-default"},[_vm._v(_vm._s(_vm.getDefaultElementLabel(element)))])]},null,element)],2)}),0),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }